<template>
  <div class="Home">
    <ModalVideo v-if="modalFlag" @closeModal="closeModal" :url="url" />
    <ModalNotice v-if="modalNoticeFlag && modal.visible" @closeModalNotice="closeModalNotice" :modal="modal"/>
    <ModalImage v-if="modalFlagImage" @closeModalImage="closeModalImage"  :url="urlSelect"/>
    <ModalVideo v-if="modalFlagVideo" @closeModal="closeModalVideo" :url="urlVideoSelect" />

    <div class="home_container" id="Home">
      <div class="preloader" :class="{hide: !preloader}">
        <div class="spinner">
          <div class="rec spinner1"></div>
        </div>
      </div>
      <div  class="app">
        <Nav/>
        <Header @openModal="openModal" v-if="!preloader"/>
        <Levels @openModal="openModal"  v-if="!preloader"/>
        <!-- <Teachers  v-if="!preloader"/> -->
        <Images  v-if="!preloader" @selectImage="selectImage"/>
        <Videos  v-if="!preloader" @selectVideo="selectVideo"/>
        <Objectives  v-if="!preloader"/>
        <Events  v-if="!preloader" />
        <Contact  v-if="!preloader"/>
        <Footer  v-if="!preloader"/>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Nav from '@/components/Nav'
import Header from '@/components/Header'
import Levels from '@/components/Levels'
import Images from '@/components/Images'
import Videos from '@/components/Videos'
import Objectives from '@/components/Objectives'
import Events from '@/components/Events'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
// import Teachers from '@/components/Teachers'
// import SweetScroll from 'sweet-scroll'
import Scrollbar from 'smooth-scrollbar'
import ModalVideo from '@/components/ModalVideo'
import ModalNotice from '@/components/ModalNotice'
import ModalImage from '@/components/ModalImage'
import { firestore } from '@/main'

export default {
  name: 'Home',
  components: {
    Nav,
    Header,
    Levels,
    Images,
    Videos,
    Objectives,
    Events,
    Contact,
    Footer,
    ModalVideo,
    ModalNotice,
    ModalImage
  },
  data: () => ({
    preloader: true,
    modalFlag: false,
    modalNoticeFlag: false,
    modalFlagImage: false,
    modalFlagVideo: false,
    url: '',
    main_link: '',
    level_one_link: '',
    level_two_link: '',
    level_three_link: '',
    modal: {
      visible: false,
      title: "",
      description: ""
    },
    urlSelect: "",
    urlVideoSelect: ""
  }),
  mounted () {
      this.$nextTick(() => {
        Scrollbar.init(document.querySelector('#Home'))
      })
      setTimeout(() => {
        this.preloader = false
      }, 2000);
       setTimeout(() => {
        const preloader = document.querySelector('.preloader')
        preloader.classList.add('done')
      }, 2000);
      setTimeout(() => {
        const preloader = document.querySelector('.preloader')
        preloader.style.display = "none"
      }, 2600);
      this.getWebInfo()
  },
  methods: {
    openModal (section) {
      this.modalFlag = !this.modalFlag
      if (section == 1) this.url = this.main_link
      else if (section == 2) this.url = this.level_one_link
      else if (section == 3) this.url = this.level_two_link
      else if (section == 4) this.url = this.level_three_link
    },
    selectImage (url) {
      if (window.innerWidth > 400) {
        this.urlSelect = url
        this.modalFlagImage = true
      }
    },
    selectVideo (url) {
      this.urlVideoSelect = url
      this.modalFlagVideo = true
    } ,
    closeModalImage () {
      this.modalFlagImage = false
    },
    closeModalVideo () {
      this.modalFlagVideo = false
    },
    closeModal () {
      this.modalFlag = false
    },
    closeModalNotice () {
      this.modalNoticeFlag = false
    },
    getWebInfo () {
      firestore.collection("web").get()
      .then((snap) => {
        snap.forEach((doc) => {
          const {main_link, level_one_link, level_two_link, level_three_link, modal} = doc.data()
          // this.infoId = doc.id
          this.main_link = main_link
          this.level_one_link = level_one_link
          this.level_two_link = level_two_link
          this.level_three_link = level_three_link
          this.modal = modal
          setTimeout(() => {
            this.modalNoticeFlag = true
          }, 4000);
        })
      })
      .catch(console.error)
    }
  }
}
</script>

<style lang="sass" scoped>
// @import '../assets/css/_variables'
@import '../assets/css/app.sass'
@import '../assets/css/spinner.scss'
.Home
  #Home
    width: 100%
    height: 100vh
    overflow: auto
    .preloader
      position: fixed
      left: 0
      top: 0
      width: 100%
      height: 100vh
      background-color: $primary_color
      z-index: 20
      display: flex
      justify-content: center
      align-items: center
      // transition: all ease-in-out .4s
      &.hide
        background-color: $secondary_color
        .spinner
          display: none
      &.done
        height: 650px
@media screen and (max-width: 980px)
  .Home
    #Home
      .preloader
        &.done
          height: 550px

@media screen and (max-width: 760px)
  .Home
    #Home
      .preloader
        &.done
          height: 700px
</style>